import React from 'react'
import { Link } from 'react-router-dom'

const fullMenu = [
  {
    name: 'Dashboard',
    path: '/dashboard/admin',
    icon: 'view-dashboard',
    dataTargetId: '#home'
  },

  {
    name: 'Master',
    path: '/master',
    icon: 'layers',
    dataTargetId: '#master',
    submenu: [
      { name: 'New Customer', path: '/master/newledger' },
      { name: 'New Supplier', path: '/master/newsupplier' },
      { name: 'New Category', path: '/master/newcategory' },
      { name: 'New Promotor', path: '/master/newpromotor' },
      { name: 'Expense Head', path: '/master/expensehead' },
      { name: 'Menu Pricing', path: '/menu/pricing' },
      

    ]
  },
  // {
  //   name: 'Menu Mgmt',
  //   path: '/menu',
  // icon: 'food',
  //   dataTargetId: '#menu',
  //   submenu: [
  //     { name: 'Menu Pricing', path: '/menu/pricing' },
  //     { name: 'Bar Management', path: '/menu/bar-management' },
  //     { name: 'Food Management', path: '/menu/food-management' },
  //   ]
  // },


  {
    name: 'Inventory',
    path: '/inventory',
    icon: 'store',
    dataTargetId: '#inventory',
    submenu: [
  // { name: 'Add New Item', path: '/inventory/newItem' },
  { name: 'Stock In/Out', path: '/inventory/stockinout' },
  { name: 'Stock Report', path: '/inventory/stockreports' },
  { name: 'Stock Report (New)', path: '/inventory/stock-report-new' },
  { name: 'Closing Stock', path: '/inventory/closing-stock' },
  { name: 'Sponsor Reports', path: '/inventory/sponsor-reports' },
  { name: 'Asset Management', path: '/inventory/assets' },


    ]
  },

  // {
  //   name: 'Sale',
  //   path: '/sale',
  //   icon: 'shopping-cart',
  //   dataTargetId: '#property',
  //   submenu: [
  //     { name: 'Advance Order', path: '/sale/advanceorder' },
  //     { name: 'POS', path: '/sale/pos' },
  //   ]
  // },

  {
    name: 'Bill Management',
    path: '/bill-management',
    icon: 'shopping-cart',
    dataTargetId: '#billmanagement',
    submenu: [
      { name: 'Cancel Bill', path: '/bill-management/cancel-bill' },
      { name: 'Move Bill', path: '/bill-management/move-entertainment' },
    ]
  },

  {
    name: 'Vouchers',
    path: '/pages/vouchers',
    icon: 'file-text',
    dataTargetId: '#reports',
    submenu: [
      { name: 'Reciept Voucher', path: '/vouchers/recieptvoucher' },
      { name: 'Payment Voucher', path: '/vouchers/paymentvoucher' },

    ]
  },
  // {
  //   name: 'Expenses',
  //   path: '/pages/expenses',
  //   icon: 'minus-circle',
  //   dataTargetId: '#reports',
  //   submenu: [
  //     { name: 'Add Expense', path: '/expenses/suppliersexpenses' },
  //     { name: 'Expense Entry', path: '/expenses/entry' },
  //     { name: 'Expense Management', path: '/expenses/expenses' },

  //   ]
  // },
  {
    name: 'Accounts',
    path: '/accounts',
    icon: 'chart-line',
    dataTargetId: '#accounts',
    submenu: [
      { name: 'Account Dashboard', path: '/accounts/dashboard' },

    ]
  },
  {
    name: 'Ledgers',
    path: '/ledgers',
    icon: 'book',
    dataTargetId: '#ledgers',
    submenu: [
      { name: 'General Ledger Entry', path: '/ledgers/general-entry' },
      { name: 'Suppliers Ledger', path: '/ledgers/suppliersledger' },
      { name: 'Customer Ledger', path: '/ledgers/customerledger' },
    ]
  },
  {
    name: 'Reports',
    path: '/pages/reports',
    icon: 'chart',
    dataTargetId: '#reports',
    submenu: [
     
      { name: 'Item Wise Sale Report', path: '/reports/item-wise-sale-report'  },
      { name: 'Bill Wise Sale Report', path: '/reports/bill-wise-sale' },
      { name: 'Date Wise Sale Report', path: '/reports/date-wise-sale' },
      { name: 'Collection Summary', path: '/collection/summary' },
      { name: 'Cashier Summaries', path: '/reports/cashier-summaries' },
      { name: 'Table History', path: '/reports/table-history' },
      { name: 'Promoter Summary', path: '/reports/promoter-summary' },
      { name: 'Daily Summary', path: '/collection/day-close', userTypes: ['admin', 'account'] },
      { name: 'AI Reports', path: '/reports/ai-reports', userTypes: ['admin'] },
      { name: 'Usage & Billing', path: '/reports/usage-billing', userTypes: ['admin'] },

    ]
  },
    {
    name: 'HR Management',
    path: '/hr',
    icon: 'accounts',
    dataTargetId: '#hr',
    submenu: [
     
      { name: 'Employee Master', path: '/hr/employee-master' },
      { name: 'Employee Records', path: '/hr/employee-records' },
      { name: 'Departments', path: '/hr/departments' },
      { name: 'Positions', path: '/hr/positions' },
      { name: 'Work Schedule', path: '/hr/work-schedule' },
      { name: 'Payroll Management', path: '/hr/payroll-management' },
      { name: 'Payroll Reports', path: '/hr/payroll-reports' },
      { name: 'Employee Payroll System', path: '/hr/employee-payroll-system' },
      { name: 'Tax & Compliances', path: '/hr/tax-compliances' }
    ]
  },

  {
    name: 'Users',
    path: '/pages/users',
    icon: 'account-circle',
    dataTargetId: '#users',
    submenu: [
      { name: 'New User', path: '/users/newuser' },
      { name: 'Edit Profile', path: '/users/editprofile' },
      { name: 'Login History', path: '/users/login-history' },
    ]
  },
  {
    name: 'Setting',
    path: '/setting',
    icon: 'settings',
    dataTargetId: '#inventory',
    submenu: [
      { name: 'Core Setting', path: '/setting/coresetting' },
      { name: 'Company Info', path: '/setting/companyinfo' },
      { name: 'Taxes', path: '/setting/taxes' },
      { name: 'Units', path: '/setting/units' },
      { name: 'Page Permissions', path: '/setting/page-permissions' },

    ]
  },
  {
    name: 'Logout',
    path: '/logout',
    icon: 'sign-in',
    dataTargetId: '#logout',
    signOut: true
  }
];
const getMenuItems = (usertype) => {
  // Normalize usertype to lowercase for consistent comparison
  const normalizedUserType = (usertype || '').toLowerCase();
  
  if (normalizedUserType === "cashier")
    {
    return fullMenu
      .filter(item => ["Dashboard", "Sale", "Reports", "Vouchers", "Logout"].includes(item.name))
      .map(item => {
        // Update Dashboard path for cashiers
        if (item.name === "Dashboard") {
          return { ...item, path: '/dashboard/cashier' };
        }
        
        if (item.submenu) 
          {
          const allowedSubmenuNames = {
            Sale: ["POS"],
            Reports: ["Sale Report", "Supplier Ledger", "Customer Ledger", "Reciept Voucher", "Payment Voucher"],
          };
          const filteredSubmenu = allowedSubmenuNames[item.name]
            ? item.submenu.filter(sub => allowedSubmenuNames[item.name].includes(sub.name))
            : item.submenu;
          return { ...item, submenu: filteredSubmenu };
        }
        return item;
      });
  }

  if (normalizedUserType === "account") {
    return fullMenu
      // Bill Management is included here even though it's off by default for
      // account - page_registry's per-user override (see
      // pageRegistryCatalog.js's bill_management.* entries) is what actually
      // shows/hides its two submenu items in LeftSidebar.jsx, same pattern
      // as every other permission-gated item.
      .filter(item => ["Dashboard", "Ledgers", "Vouchers", "Reports", "Bill Management", "Users", "Logout"].includes(item.name))
      .map(item => {
        // Update Dashboard path for account users
        if (item.name === "Dashboard") {
          return { ...item, path: '/accounts/dashboard' };
        }
        if (item.name === "Reports" && item.submenu) {
          // Show specific Reports submenu for Account including all sale reports
          const accountAllowedReports = [
            'Item Wise Sale Report',
            'Bill Wise Sale Report',
            'Date Wise Sale Report',
            'Collection Summary',
            'Cashier Summaries',
            'Table History',
            'Daily Summary'
          ];
          return { 
            ...item, 
            submenu: item.submenu.filter(sub => accountAllowedReports.includes(sub.name))
          };
        }
        if (item.name === "Users" && item.submenu) {
          // Allow account users to access Edit Profile only
          return { 
            ...item, 
            submenu: item.submenu.filter(sub => sub.name === 'Edit Profile')
          };
        }
        return item;
      });
  }

  if (normalizedUserType === "wstoremanager" || normalizedUserType === "warehousestoremanager") {
    return fullMenu
      .filter(item => ["Dashboard", "Inventory", "Logout"].includes(item.name))
      .map(item => {
        // Update Dashboard path for warehouse store managers
        if (item.name === "Dashboard") {
          return { ...item, path: '/dashboard/warehousestoremanager' };
        }
        if (item.name === "Inventory" && item.submenu) {
          // Show all Inventory submenu items for warehouse managers
          const inventoryAllowedItems = [
            'Stock In/Out',
            'Stock Report',
            'Stock Report (New)',
            'Closing Stock',
            'Asset Management'
          ];
          return { 
            ...item, 
            submenu: item.submenu.filter(sub => inventoryAllowedItems.includes(sub.name))
          };
        }
        return item;
      });
  }

  if (normalizedUserType === "modifier") {
    return fullMenu
      .filter(item => ["Bill Management", "Reports", "Logout"].includes(item.name))
      .map(item => {
        // Modifier users get limited access to Reports submenu (only Collection Summary)
        if (item.name === "Reports") {
          return {
            ...item,
            submenu: item.submenu.filter(subItem => subItem.name === "Collection Summary")
          };
        }
        return item;
      });
  }

  if (normalizedUserType === "hr") {
    return fullMenu
      .filter(item => ["Dashboard", "HR Management", "Logout"].includes(item.name))
      .map(item => {
        // Update Dashboard path for HR users
        if (item.name === "Dashboard") {
          return { ...item, path: '/hr/analytics-dashboard' };
        }
        // HR users get full access to all HR Management submenu items
        return item;
      });
  }

  // Default for Admin or other full-access users
  return fullMenu;
};


export default getMenuItems;
